import React, { useEffect, useCallback } from "react";
import SocketIOClient from "socket.io-client";
import { extractHostname } from "../utils";
var ActivityTracking = function ActivityTracking() {
  useEffect(function () {
    var organisationId = "c302cbfe-ed9b-41b3-aba0-978034122bea";
    var socket = SocketIOClient.connect("http://139.59.89.196:8080?authorization=".concat(organisationId));
    socket.emit("join", organisationId);
    socket.on("app_change", handleAppChange);
  }, []);
  var handleAppChange = useCallback(function (event) {
    var app = event.url ? extractHostname(event.url) : (event === null || event === void 0 ? void 0 : event.appFileName) || (event === null || event === void 0 ? void 0 : event.app);
    document.querySelector("#apps").innerHTML += "<br /> ".concat(new Date(), " ").concat(app || "unknown app");
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    id: "apps"
  });
};
export default ActivityTracking;